<template>
  <v-card flat v-if="!loading">
    <v-list two-line>
      <v-subheader>
        <v-layout justify-space-between>
          <v-flex xs6 md3 class="text-sm-left font-weight-bold text--primary">
            Comentarios:
          </v-flex>
          <v-flex xs4 md3 class="text-sm-right">
            {{ commentsCount }}
          </v-flex>
        </v-layout>
      </v-subheader>

      <template v-for="(comment, index) in comments">
        <v-list-tile
          :key="comment.id"
          avatar
          class="comment-list"
        >
          <v-list-tile-avatar>
            <img :src="comment.avatar">
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              <router-link :to="`/usuario/${comment.user_id}`" class="link-name-user">
                <span class="font-weight-bold">{{ comment.user_favorite_name }}</span> - <span class="caption">{{ comment.created_at }} hrs</span>
              </router-link>
            </v-list-tile-title>

            <div>
              {{comment.content}}
            </div>
          </v-list-tile-content>
          
          <v-list-tile-action>
            <v-btn 
              flat 
              small
              fab
              color="error" 
              @click="showAlert(comment.id)"
              v-if="permitDelete(comment.user_id)"
            >
              <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/clear.svg" class="icon-clear" alt="">
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="`${index}-${comment.id}`"></v-divider>
      </template>

      <v-btn 
        flat 
        small 
        color="primary"
        @click="handleSeeMore()"
        v-if="this.comments.length < totalComments"
      >
        Ver más
      </v-btn>
    </v-list>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Swal from "sweetalert2"

export default {
  props: {
    comments: { type: Array, required: true },
    postSlug: { type: String, required: true },
    page: { type: Number, required: true }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapState("comments", ["totalComments", "loading"]),
    commentsCount() {
      let quantity = this.totalComments
      return quantity === 1 ? `${quantity} comentario` : `${quantity} comentarios`
    }
  },
  methods: {
    ...mapActions("comments", ["deleteComment", "fetchComments"]),
    async handleDelete(id) {
      await this.deleteComment({ slug: this.postSlug, commentId: id })
      this.$emit("set-page", 1)
      this.fetchComments({ slug: this.postSlug, page: 1 })
    },
    permitDelete(userId) {
      return this.current_user.role.includes('admin') || userId === this.current_user.id
    },
    showAlert(id) {
      Swal.fire({ 
        title: "¿Estás seguro de eliminar este comentario?",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) this.handleDelete(id)
      });
    },
    async handleSeeMore() {
      await this.fetchComments({ slug: this.postSlug, page: this.page + 1})
      this.$emit("set-page", this.page + 1)
    }
  },
}
</script>
<style lang="css">
.link-name-user {
  text-decoration: none; 
  color: black;
}

.comment-list > .v-list__tile {
  height: 100% !important;
  padding: 10px 10px !important;
}
.icon-clear{
  width: 10px;
  filter: invert(54%) sepia(12%) saturate(2603%) hue-rotate(314deg) brightness(102%) contrast(94%);
}
</style>